/**
* 订单管理 订单管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>投诉管理</el-breadcrumb-item>
    </el-breadcrumb>

<!--    <div style="line-height: 28px; margin-top: 20px;font-size: 16px">
      订单总金额:
      <span style="font-size: 30px; color: #54acf7">{{
        totalAmount
      }}</span>
      元
    </div> -->

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
<!--      </el-form-item>
      <el-form-item label="订单号:">
        <el-input size="small" v-model="formInline.orderNo" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input size="small" v-model="formInline.userName" placeholder="请输入手机号"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="支付类型:">
        <el-select size="small" v-model="formInline.payType" placeholder="请选择">
          <el-option v-for="types in payType" :label="types.key" :value="types.value" :key="types.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="套餐查询:">
        <el-select v-model="formInline.rtid" size="small" style="width: 100%;" placeholder="请选择套餐">
          <el-option
            v-for="item in listDataArr"
            :key="item.id"
            :label="item.title"
            align="center"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
<!--     <el-form-item label="支付时间:">
        <el-select size="small" v-model="formInline.payTimeType" placeholder="请选择">
          <el-option v-for="types in payTimeType" :label="types.key" :value="types.value" :key="types.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="公司名称:">
        <el-select size="small" v-model="formInline.oppositeName" placeholder="请选择">
          <el-option v-for="types in oppositeName" :label="types.key" :value="types.value" :key="types.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" label="ID" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="tradeNo" label="订单号" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="contact" label="用户手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="complainContent" label="投诉内容" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="complainAmount" label="订单金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="complaintTradeInfoList[0].gmtTrade" :formatter="(row, col, value) => {
      const pad = n => n.toString().padStart(2, '0')
      const date = new Date(value)
      return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}
              ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }" label="下单时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="gmtComplain" :formatter="(row, col, value) => {
      const pad = n => n.toString().padStart(2, '0')
      const date = new Date(value)
      return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}
              ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }" label="投诉时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="statusDescription" label="处理状态" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="oppositeName" label="公司名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row, 0)">退款处理</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row, 1)">其他处理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" :close-on-click-modal="false"
      :close-on-press-escape="false" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm">

        <el-form-item prop="orderid" label="订单号">
          <el-input size="small" v-model="editForm.orderid" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="用户手机号">
          <el-input size="small" v-model="editForm.phone" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="goodsName" label="订单名称" v-if="!isAdmin">
          <el-input size="small" v-model="editForm.goodsName" auto-complete="off" disabled></el-input>
        </el-form-item>
        <!--套餐金额  连接数 是火箭加速AI加速特有的-->
        <!-- <el-form-item prop="vipMoney" label="套餐金额">
          <el-input size="small" v-model="editForm.vipMoney" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item prop="linkNum" label="连接数">
          <el-input size="small" v-model="editForm.linkNum" auto-complete="off" disabled></el-input>
      </el-form-item> -->
        <!-- <el-table-column align="center" prop="goodsMoney" label="套餐金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="goodsMoney" label="连接数" width="120" show-overflow-tooltip>
      </el-table-column> -->
        <el-form-item prop="goodsMoney" label="订单金额">
          <el-input size="small" v-model="editForm.goodsMoney" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="createTime" label="下单时间" v-if="!isAdmin">
          <el-input size="small" v-model="editForm.createTime" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="payTime" label="支付时间">
          <el-input size="small" v-model="editForm.payTime" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="payStatus" label="支付状态">
          <el-input size="small" v-model="editForm.payStatus" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="payType" label="支付类型" v-if="!isAdmin">
          <el-input size="small" v-model="editForm.payType" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="退款金额" v-if="editForm.payStatus === '支付成功' && isAdmin">
          <el-input size="small" v-model="money" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="会员时间" v-if="isAdmin">
          <el-input size="small" v-model="deadline" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="拉黑原因" v-if="isAdmin">
          <el-input size="small" v-model="reason" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>关闭</el-button>
        <el-button ref="refundButton" v-if="editForm.payStatus === '支付成功' && isAdmin" size="mini" type="danger"
          @click="deleteUser(editForm)">
          退款
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    OrderList,
    userRefunds,
    dealUserComplaint,
    complaintsPage
  } from '../../api/payMG'
  import {
    getUserInfo
  } from '../../api/userMG.js'

  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        isAdmin: false,
        deadline: '2008-02-07 00:00:00',
        reason: '',
        listDataArr: [],
        editFormVisible: false, //控制编辑页面显示与隐藏
        money: 0,
        totalAmount: 0.0,
        title: '预览',
        payType: [{
            key: '全部',
            value: null
          },
          {
            key: '支付宝',
            value: 0
          },
          {
            key: '微信',
            value: 1
          },
          // { key: '小程序-Android', value: 3 },
          // { key: '小程序-ios', value: 4 },
          // { key: '幻影分身', value: 5 },
        ],
        oppositeName: [{
            key: '幻宇宙科技',
            value: 1
          },
          {
            key: '范特姆科技',
            value: 2
          },
          {
            key: '义乌扣叮',
            value: 3
          },
          {
            key: '码帮科技',
            value: 4
          },
          {
            key: '遂昌扣叮',
            value: 5
          },
          {
            key: '炁聿阁',
            value: 6
          },
          // { key: '支付失败', value: -1 },
          // { key: '支付失效', value: -2 },
          // { key: '已拉黑', value: -3 },
          // {
          //   key: '已退款',
          //   value: 3
          // },
        ],
        payTimeType: [{
            key: '全部',
            value: null
          },
          {
            key: '今天',
            value: 0
          },
          {
            key: '昨天',
            value: 1
          },
          {
            key: '近7天',
            value: 2
          },
          // { key: '支付失效', value: -2 },
          // { key: '已拉黑', value: -3 },
          {
            key: '近30天',
            value: 3
          },
        ],
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          role: ''
        },
        formInline: {
          pageNo: 1,
          pageSize: 10,
          machineNo: '',
          orderNo: '',
          userName: "",
          transId: '',
          oppositeName: 1,
          rtid: null,
          payType: null,
          payStatus: null,
          payTimeType: null,
          token: localStorage.getItem('logintoken')
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    mounted() {
      if (this.$route.query && this.$route.query.orderNum) {
        this.formInline.orderNo = this.$route.query.orderNum
      }
      if (this.$route.query && this.$route.query.userName) {
        this.formInline.userName = this.$route.query.userName
      }
      if (this.$route.query && this.$route.query.taoCan) {
        this.formInline.rtid = this.$route.query.taoCan * 1
      }
      this.getdata(this.formInline)
      let role = JSON.parse(localStorage.getItem('userdata')).role;
      this.isAdmin = (role === 'admin');
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        // 模拟数据开始
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        complaintsPage(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.complaintList
              this.totalAmount = res.data.totalAmount
              // 分页赋值
              this.pageparm.currentPage = this.formInline.current
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNo = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.pageNo = 1
        this.getdata(this.formInline)
      },
      //处理投诉
      handleEdit: function(index, row, type) {
        this.editForm = row
        this.money = this.editForm.goodsMoney * 1
        this.deadline = '2008-02-07 00:00:00'
        this.reason = ''


        this.$confirm('确定已经退款了吗?', '处理投诉', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            dealUserComplaint({
                id: row.id,
                oppositeName: this.formInline.oppositeName,
                type: type
              })
              .then(res => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '处理成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('操作失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })

      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            ConfigSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 退款
      deleteUser(row) {
        if (row.payStatus != '支付成功') {
          this.$message.warning('支付成功的订单才支持退款！')
          return
        }
        if (this.money <= 0 || this.money > row.goodsMoney) {
          this.$message.warning('请输入正确的退款金额！')
          return
        }
        this.$confirm('确定要退款吗?', '退款', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            userRefunds({
                id: row.id,
                refundMoney: this.money,
                deadline: this.deadline,
                reason: this.reason,
              })
              .then(res => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '退款成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('操作失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消退款'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        // this.$refs[formName].resetFields()
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/Complaint.vue